// Shared styles for all Artemis components
export const themeStyles = {
  userNode: {
    background: 'linear-gradient(135deg, #5E60CE 0%, #4458DC 100%)',
    border: '2px solid #4458DC',
    borderRadius: '12px',
    padding: '16px 20px',
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 180,
    textAlign: 'center',
    boxShadow: '0 4px 12px rgba(69, 88, 220, 0.3)',
  },
  problemNode: {
    background: 'linear-gradient(135deg, #FF6B6B 0%, #EE5A6F 100%)',
    border: '2px solid #EE5A6F',
    borderRadius: '16px',
    padding: '20px 24px',
    fontSize: '16px',
    fontWeight: '700',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 280,
    textAlign: 'center',
    boxShadow: '0 6px 20px rgba(238, 90, 111, 0.3)',
  },
  codeNode: {
    background: '#1E1E1E',
    border: '1px solid #333333',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '12px',
    fontFamily: '"JetBrains Mono", "Consolas", monospace',
    color: '#E8E8E8',
    width: 300,
    textAlign: 'left',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
  },
  analysisNode: {
    background: 'linear-gradient(135deg, #4ECDC4 0%, #44A3AA 100%)',
    border: '2px solid #44A3AA',
    borderRadius: '12px',
    padding: '16px 20px',
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 200,
    textAlign: 'center',
    boxShadow: '0 4px 12px rgba(68, 163, 170, 0.3)',
  },
  llmNode: {
    background: 'linear-gradient(135deg, #667EEA 0%, #764BA2 100%)',
    border: '2px solid #764BA2',
    borderRadius: '12px',
    padding: '14px 18px',
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 160,
    textAlign: 'center',
    boxShadow: '0 4px 12px rgba(118, 75, 162, 0.3)',
  },
  suggestionNode: {
    background: 'linear-gradient(135deg, #A8E6CF 0%, #7FD1AE 100%)',
    border: '2px solid #7FD1AE',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '12px',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#1A1A1A',
    width: 240,
    textAlign: 'left',
    boxShadow: '0 3px 10px rgba(127, 209, 174, 0.3)',
  },
  evolvedNode: {
    background: 'linear-gradient(135deg, #FFD93D 0%, #FFB344 100%)',
    border: '2px solid #FFB344',
    borderRadius: '12px',
    padding: '14px',
    fontSize: '13px',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#1A1A1A',
    width: 260,
    textAlign: 'left',
    boxShadow: '0 4px 15px rgba(255, 179, 68, 0.3)',
    animation: 'pulse 2s infinite',
  },
  scoreNode: {
    background: 'linear-gradient(135deg, #6BCF7F 0%, #52B69A 100%)',
    border: '2px solid #52B69A',
    borderRadius: '50%',
    padding: '16px',
    fontSize: '14px',
    fontWeight: '700',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 100,
    height: 100,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(82, 182, 154, 0.3)',
  },
  uniqueFeatureNode: {
    background: 'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)',
    border: '2px solid #FF6D00',
    borderRadius: '16px',
    padding: '18px 24px',
    fontSize: '15px',
    fontWeight: '700',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#ffffff',
    width: 280,
    textAlign: 'center',
    boxShadow: '0 6px 20px rgba(255, 109, 0, 0.4)',
  },
  metricNode: {
    background: '#F5F5F5',
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    padding: '10px 14px',
    fontSize: '12px',
    fontWeight: '600',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#424242',
    width: 140,
    textAlign: 'center',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
  },
  edgeStyle: {
    stroke: '#9CA3AF',
    strokeWidth: 2,
  },
  evolutionEdgeStyle: {
    stroke: '#FF6D00',
    strokeWidth: 3,
    strokeDasharray: '8 4',
    animation: 'dash 2s linear infinite',
  },
  feedbackEdgeStyle: {
    stroke: '#6BCF7F',
    strokeWidth: 2.5,
    strokeDasharray: '4 4',
  }
};

// Custom CSS animations with better performance
export const customStyles = `
  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 15px rgba(255, 179, 68, 0.3);
    }
    50% {
      transform: scale(1.02);
      box-shadow: 0 6px 20px rgba(255, 179, 68, 0.5);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 4px 15px rgba(255, 179, 68, 0.3);
    }
  }
  
  @keyframes dash {
    to {
      stroke-dashoffset: -16;
    }
  }
  
  .react-flow__node {
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  }
  
  .react-flow__edge-path {
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  /* C++ Syntax Highlighting */
  .cpp-keyword { color: #569CD6 !important; font-weight: 600; }
  .cpp-preprocessor { color: #9CDCFE !important; }
  .cpp-number { color: #B5CEA8 !important; }
  .cpp-comment { color: #6A9955 !important; font-style: italic; }
  .cpp-string { color: #CE9178 !important; }
  .cpp-operator { color: #D4D4D4 !important; }
  .cpp-template { color: #4EC9B0 !important; }
  .cpp-type { color: #4EC9B0 !important; font-weight: 500; }
`;

// Enhanced syntax highlighting helper for C++ using React components
export const syntaxHighlight = (code) => {
  // Split code into tokens and return plain text with proper spacing
  return code
    // Just return the code as-is, we'll style it with CSS instead
    .replace(/\t/g, '    '); // Convert tabs to spaces for consistent display
}; 